import * as React from 'react';
import {
  IMortgageCalculatorContext,
  MortgageCalculatorContextProvider,
} from '../../contexts/MortgageCalculatorContext';
import { MortgageSectionContainer } from '../MortgageSection';
import { useSelector } from 'react-redux';
import { mortgageCalculatorSelector } from '../../../../selectors/mortgageCalculator/mortgageCalculatorSelector';
import { FILTERS } from '../../constants/mortgage';
import { Layout } from '../../../../components/Layout';

export const MortgageCalculator: React.FC = () => {
  const mortgageCalculator = useSelector(mortgageCalculatorSelector);

  const context = React.useMemo<IMortgageCalculatorContext | null>(
    () =>
      mortgageCalculator
        ? {
            banks: mortgageCalculator.banks,
            mortgagePromos: mortgageCalculator.mortgagePromos,
            fromDeveloperMaxPrice: mortgageCalculator.fromDeveloperMaxPrice ?? FILTERS.DEFAULT_MAX_PRICE,
            fromDeveloperMinPrice: mortgageCalculator.fromDeveloperMinPrice ?? FILTERS.DEFAULT_MIN_PRICE,
            mortgageSeoPageUrl: mortgageCalculator.mortgageSeoPageUrl,
          }
        : null,
    [mortgageCalculator],
  );

  if (!context) {
    return null;
  }

  return (
    <Layout>
      <MortgageCalculatorContextProvider value={context}>
        <MortgageSectionContainer />
      </MortgageCalculatorContextProvider>
    </Layout>
  );
};
